import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import CheckboxFormik from "app/pages/.shared/form/CheckboxFormik";
import { Field } from "formik";

const PaymentTermsInput = ({
	cgvDocumentName,
	informationStandardForm,
	onBlur = () => {},
	showInformationStandardForm,
	brandDisplayName,
	showPfsMessage,
}) => {
	const intl = useIntl();

	return (
		<Field
			component={CheckboxFormik}
			name="terms"
			id="accept-terms"
			grouped={false}
			showIcon={true}
			isRequired={true}
			toggle={onBlur}
			data-testid="payment-terms-input"
		>
			<FormattedMessage
				values={{
					cgvLink: (
						<FormattedMessage id="general.cgv">
							{message => (
								<a
									className="relative-link"
									rel="noopener noreferrer"
									target="_blank"
									href={cgvDocumentName}
								>
									{message}
								</a>
							)}
						</FormattedMessage>
					),
					secondaryLink: showInformationStandardForm && (
						<FormattedMessage id="payment.form.info.standard.link">
							{message => (
								<a
									className="relative-link"
									rel="noopener noreferrer"
									target="_blank"
									href={informationStandardForm}
								>
									{message}
								</a>
							)}
						</FormattedMessage>
					),
					brandName: showPfsMessage
						? intl.formatMessage(
								{
									id: "general.perfectstay.partnership.name",
								},
								{ brandName: brandDisplayName }
							)
						: brandDisplayName,
					showPfsMessage,
				}}
				id="payment.terms.label"
			/>
		</Field>
	);
};

PaymentTermsInput.propTypes = {
	cgvDocumentName: PropTypes.string,
	informationStandardForm: PropTypes.string,
	onBlur: PropTypes.func,
	showInformationStandardForm: PropTypes.bool,
	brandDisplayName: PropTypes.string,
	showPfsMessage: PropTypes.bool,
};

export default PaymentTermsInput;
